import { createAppStore } from '@store/createAppStore';
import { CustomerContractState } from '@store/customers/customerDetails/contracts';

const [customerContractStore, setCustomerContract] =
  createAppStore<CustomerContractState>(
    {
      customerContract: null,
      isLoading: false,
      error: '',
    },
    'customerContractStore',
  );

export { customerContractStore, setCustomerContract };
